<template>
  <section class="addOns">
    <div v-if="!parentProduct" class="addOnDivider"></div>
    <SimpleProduct
      v-if="!parentProduct"
      :addOn="addOn"
      :product="product"
    />
    <SimpleProduct
      v-if="parentProduct"
      :addOn="qualification"
      :product="product"
    />
  </section>
</template>

<script>
import SimpleProduct from './SimpleProduct.vue'
export default {
  components: {
    SimpleProduct,
  },
  computed: {
    addOn() {
      if (!this.qualification.isAddOn) {
        return this.qualification.addOns[Object.keys(this.qualification.addOns)[0]]
      } else {
        return false
      }
    },
  },
  props: {
    product: Object,
    qualification: Object,
    parentProduct: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  section {
    .addOnDivider {
      border-top: 1px solid #DADBDB;
      margin-top: 5px;
    }
  }
</style>
